import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import IconDelete from 'material-ui/svg-icons/action/delete';

import FormAddress from '../FormAddress/FormAddress';
import FormContactDetail from '../FormContactDetail/FormContactDetail';
import DeletePlaceholderEmbed from '../DeletePlaceholderEmbed/DeletePlaceholderEmbed';
import PeoplePicker from '../../components/PeoplePicker/PeoplePicker';

import mergeStates from '../../helpers/mergeStates';
import classes from './FormPlaceEmbed.scss';
import SimplDatepicker from '../SimplDatepicker/SimplDatepicker';

class FormPlaceEmbed extends React.Component {
  handleChange = e => {
    const nextState = mergeStates(e, this.props.companyAddress);
    this.props.onChange(nextState);
  };

  handleCeoChange = e => {
    this.props.onChange({
      ...this.props.companyAddress,
      ceo_id: e.target.value,
    });
  };

  handleFoundationDate = date => {
    if (typeof date !== 'undefined' && date) {
      this.props.onChange({ ...this.props.companyAddress, foundation: date });
    } else {
      this.props.onChange({ ...this.props.companyAddress, foundation: '' });
    }
  };

  addContactDetail = e => {
    if (typeof e !== 'undefined' && e.button !== 0) {
      // abort on not left click
      return;
    }

    let contactDetails = [];
    if (typeof this.props.companyAddress.contact_details !== 'undefined') {
      contactDetails = _.clone(this.props.companyAddress.contact_details);
    }

    contactDetails.push({
      id: `new_${Date.now()}`,
      value: '',
      type: 'email',
      note: '',
    });

    this.props.onChange({
      ...this.props.companyAddress,
      contact_details: contactDetails,
    });
  };

  applyContactDetailChange = contactDetail => {
    const nextProps = _.clone(this.props.companyAddress);

    for (let i = nextProps.contact_details.length - 1; i >= 0; i--) {
      if (contactDetail.id === nextProps.contact_details[i].id) {
        nextProps.contact_details[i] = contactDetail;
      }
    }

    this.props.onChange(nextProps);
  };

  handleContactDetailDeletion = contactDetail => {
    const nextState = this.state;

    for (let i = nextState.contactDetails.length - 1; i >= 0; i--) {
      if (contactDetail.id === nextState.contactDetails[i].id) {
        nextState.contactDetails.splice(i, 1);
      }
    }

    this.setState(nextState);
  };

  applyAddressChange = address => {
    this.props.onChange({ ...this.props.companyAddress, address });
  };

  renderContactDetails = () => {
    const contactDetails = [];

    if (typeof this.props.companyAddress.contact_details !== 'undefined') {
      this.props.companyAddress.contact_details.forEach(detail => {
        contactDetails.push(
          <FormContactDetail
            key={`contactDetail_${detail.id}`}
            contactDetail={detail}
            onChange={contactDetail => {
              this.applyContactDetailChange(contactDetail);
            }}
            onDelete={contactDetail => {
              this.handleContactDetailDeletion(contactDetail);
            }}
          />,
        );
      });
    } else {
      this.addContactDetail();
    }

    return contactDetails;
  };

  setDeleteFlag = (event, unset) => {
    if (typeof unset !== 'undefined' && unset === true) {
      this.props.onChange({
        ...this.props.companyAddress,
        delete_this_place: null,
      });
    } else {
      this.props.onChange({
        ...this.props.companyAddress,
        delete_this_place: this.props.companyAddress.id,
      });
    }
  };

  render() {
    let heading = 'Neuer Standort';
    let deleteButtonText = 'Standort';
    if (
      typeof this.props.companyAddress.title !== 'undefined' &&
      this.props.companyAddress.title.length
    ) {
      heading = this.props.companyAddress.title;
      deleteButtonText = heading;
    }

    if (
      typeof this.props.companyAddress.delete_this_place !== 'undefined' &&
      this.props.companyAddress.delete_this_place
    ) {
      return (
        <DeletePlaceholderEmbed
          name={deleteButtonText}
          onCancel={e => this.setDeleteFlag(e, true)}
        />
      );
    }

    let ceo = null;
    if (
      typeof this.props.companyAddress.ceo_id !== 'undefined' &&
      this.props.companyAddress.ceo_id !== 0 &&
      typeof this.props.companyAddress.ceo_type !== 'undefined' &&
      this.props.companyAddress.ceo_type !== ''
    ) {
      if (this.props.companyAddress.ceo_type === 'App\\Staff') {
        ceo = `staff[${this.props.companyAddress.ceo_id}]`;
      } else if (this.props.companyAddress.ceo_type === 'App\\Person') {
        ceo = `person[${this.props.companyAddress.ceo_id}]`;
      }
    }

    return (
      <div className={classes.form}>
        <Card className={classes.card}>
          <CardHeader
            title={heading}
            actAsExpander
            showExpandableButton
            className={classes.cardHeader}
            titleStyle={{
              color: '#4a4a4a',
              fontWeight: 700,
              fontSize: '18px',
            }}
          />

          <CardText expandable className={classes.cardText}>
            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="title">
                  Standortbezeichnung
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <input
                  name="title"
                  value={this.props.companyAddress.title}
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>

            <FormAddress
              value={this.props.companyAddress.address}
              onChange={address => {
                this.applyAddressChange(address);
              }}
            />

            <hr />

            <div className="row">
              <div className="col-xs-12">
                <h2>Kommunikation</h2>
              </div>
            </div>

            {this.renderContactDetails()}

            <div className="row">
              <div className="col-xs-12 text-center">
                <button
                  className="button button--link"
                  onMouseDown={e => {
                    this.addContactDetail(e);
                  }}
                >
                  + Kommunikationsart hinzufügen
                </button>
              </div>
            </div>

            <hr />

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="type">
                  Art des Betriebs
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <input
                  name="type"
                  value={this.props.companyAddress.type}
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="register_entry">
                  Handelsregistereintrag
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <input
                  name="register_entry"
                  value={this.props.companyAddress.register_entry}
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="foundation">
                  Betriebsgründung
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <SimplDatepicker
                  defaultValue={this.props.companyAddress.foundation}
                  onChange={date => {
                    this.handleFoundationDate(date);
                  }}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="ceo">
                  Betriebsleiter
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <PeoplePicker
                  type="all"
                  name="ceo"
                  clearable={false}
                  default={ceo}
                  onChange={e => this.handleCeoChange(e)}
                />
              </div>
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <label className="simpl-label" htmlFor="notes">
                  Bemerkungen
                </label>
              </div>
              <div className="col-xs-12 col-sm-8">
                <textarea
                  name="notes"
                  value={this.props.companyAddress.notes}
                  rows="4"
                  cols="12"
                  onChange={e => this.handleChange(e)}
                />
              </div>
            </div>

            <div className={classes.cardFooter}>
              <span
                className={classes.cardButton}
                onMouseDown={e => this.setDeleteFlag(e)}
              >
                <IconDelete /> {deleteButtonText} entfernen
              </span>
            </div>
          </CardText>
        </Card>
      </div>
    );
  }
}
FormPlaceEmbed.propTypes = {
  onChange: PropTypes.func.isRequired,
  companyAddress: PropTypes.object.isRequired,
};
export default FormPlaceEmbed;



// WEBPACK FOOTER //
// ./src/components/FormPlaceEmbed/FormPlaceEmbed.js